export default "__VITE_ASSET__C8hP6u3e__"